// Crisp SVG radial chart for AI compatibility score (0-100).
export default function ScoreRadial({ score = 0, size = 140, stroke = 10, label = "Compatibility" }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (Math.max(0, Math.min(100, score)) / 100) * c;
  return (
    <div className="flex items-center gap-4" data-testid="score-radial">
      <svg width={size} height={size} className="block">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#D2D2D0" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="#002FA7"
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={`${dash} ${c}`}
          strokeLinecap="butt"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          className="font-mono"
          fontSize={size * 0.28}
          fill="#0F0F0F"
        >
          {Math.round(score)}
        </text>
      </svg>
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-quiet">
          {label}
        </div>
        <div className="font-serif text-3xl text-ink mt-1 leading-none">
          {Math.round(score)}<span className="text-quiet text-lg">/100</span>
        </div>
      </div>
    </div>
  );
}

export function ScoreBar({ label, value }) {
  const v = Math.max(0, Math.min(100, value));
  return (
    <div className="space-y-1">
      <div className="flex justify-between font-mono text-[11px]">
        <span className="text-quiet uppercase tracking-wider">{label}</span>
        <span className="text-ink">{Math.round(v)}</span>
      </div>
      <div className="h-1.5 bg-rule">
        <div className="h-full bg-ink" style={{ width: `${v}%` }} />
      </div>
    </div>
  );
}
